export const RoutingEvent = {
  ROUTING_STARTED: 'routing.started',
  ROUTING_STOPPED: 'routing.stopped',
  WAYPOINTS_CHANGE: 'routing.waypoints-change',
  POINTER_ENTER_WAYPOINT: 'routing.pointer-enter-waypoint',
  POINTER_EXIT_WAYPOINT: 'routing.pointer-exit-waypoint',
  CLICK_ON_WAYPOINT: 'routing.click-on-waypoint',
  WAYPOINT_DRAGGED: 'routing.waypoint-moved',
  WAYPOINT_POINTER_UP: 'routing.waypoint-pointer-up',
  CLICK_ON_MAP: 'routing.click-on-map',
  ROUTE_CHANGED: 'routing.route-changed',
  ROUTE_RESET: 'routing.route-reset',
  ISOCHRONE_RESULT_CHANGED: 'routing.isochrone-result-changed',
  ROUTING_MODE_CHANGED: 'routing.routing-mode-changed',
  ROUTE_DIALOG_CLOSED: 'routing.save-route-dialog-closed',
  LAYER_POLYGON_ADDED_AS_AVOIDANCE_ZONE: 'layer-polygon-added-as-avoidance-zone'
};

export const RoutingFeatureProperty = {
  TYPE: 'routingFeatureType'
};

export const RoutingFeatureType = {
  WAYPOINT: 'waypoint',
  ROUTE: 'route'
};
